import { Tooltip } from '@strivelabs/ui-core/v2';
import { useSidebar } from '@strivelabs/ui-blocks/v2';
import { RailCollapseIcon, RailExpandIcon } from '../icons/SidebarIcons';

/**
 * Collapse affordance (Home Shell design: a 26px ghost button with the panel
 * glyph at 15px, quiet at rest and full ink on hover). The ⌘B shortcut itself
 * is owned by the Sidebar shell, so this only exposes it to the pointer and
 * announces the state.
 */
export function CollapseToggle() {
  const { collapsed, toggleCollapsed } = useSidebar();
  const label = collapsed ? 'Expand sidebar' : 'Collapse sidebar';
  const Icon = collapsed ? RailExpandIcon : RailCollapseIcon;

  return (
    <Tooltip label={label} shortcut="⌘B" side="right">
      <button
        type="button"
        aria-label={label}
        aria-expanded={!collapsed}
        onClick={toggleCollapsed}
        className="grid size-[26px] shrink-0 place-items-center rounded-v2-md text-[15px] text-v2-sidebar-foreground/[0.42] transition-colors duration-v2-quick hover:bg-v2-sidebar-accent hover:text-v2-sidebar-foreground focus-visible:bg-v2-sidebar-accent focus-visible:text-v2-sidebar-foreground focus-visible:outline-none"
      >
        <Icon />
      </button>
    </Tooltip>
  );
}
